import { stegaClean } from 'next-sanity'

import { ARTICLE_BLOCK_SPACING } from '@/app/utils/articleBlock'
import { cn } from '@/app/utils/style'
import type { ExternalVideo as ExternalVideoType } from '@/sanity.types'

interface ExternalVideoProps {
  value: ExternalVideoType
  className?: string
}

export function ExternalVideo({ value, className }: ExternalVideoProps) {
  const url = stegaClean(value.url)
  if (!url) return null

  return (
    <figure className={cn(ARTICLE_BLOCK_SPACING, className)}>
      <video src={url} controls playsInline preload="metadata" className="w-full bg-neutral-100" />
      {value.caption && (
        <figcaption className="size-body-xs mt-sm font-medium">{value.caption}</figcaption>
      )}
    </figure>
  )
}
